export enum EngagementAssociatedType {
  User = 'USER',
  Organisation = 'ORGANISATION',
}

export enum EngagementType {
  AddMonitoringDomain = 'MONITORING_ADD_DOMAIN',
  MonitoringBenefits = 'MONITORING_BENEFITS',
  PLGPostAssessmentModal = 'PLG_POST_ASSESSMENT_MODAL',
  PLGPostReassessmentModal = 'PLG_POST_REASSESSMENT_MODAL',
  SupplierAssessmentPdfExported = 'SUPPLIER_ASSESSMENT_PDF_EXPORTED',
  SupplierAssessmentCsvExported = 'SUPPLIER_ASSESSMENT_CSV_EXPORTED',
  SupplierAssessmentApproved = 'SUPPLIER_ASSESSMENT_APPROVED',
  SupplierAssessmentRejected = 'SUPPLIER_ASSESSMENT_REJECTED',
  SupplierConnectionRequested = 'SUPPLIER_CONNECTION_REQUESTED',
  AutoSuggestModal = 'AUTO_SUGGEST_MODAL',
  AutoSuggestBanner = 'AUTO_SUGGEST_BANNER',
  StartCompletingProfileBanner = 'START_COMPLETING_PROFILE_BANNER',
  ClientMonitoringInterestDismissed = 'CLIENT_MONITORING_INTEREST',
  WelcomeModal = 'WELCOME_MODAL',
  GettingStartedAddColleague = 'GETTING_STARTED_ADD_COLLEAGUE',
  ClientScoringV2BannerClick = 'CLIENT_SCORING_V2_BANNER_CLICK',
  ClientScoringV2BannerView = 'CLIENT_SCORING_V2_BANNER_VIEW',
  CertificateDiscoveryFeedback = 'CERTIFICATE_DISCOVERY_FEEDBACK',
  ClientTrialAssessmentView = 'CLIENT_TRIAL_ASSESSMENT_VIEW',
}

export type Engagement = {
  id: string;
  associatedType: EngagementAssociatedType;
  associatedID: string;
  engagementType: EngagementType;
  engagementCount: number;
  lastTrackingID: string;
};
